document.addEventListener('DOMContentLoaded', function () {
    const lightbox = GLightbox();

    handleAudio();

    function handleAudio() {
        document.querySelectorAll('[data-audio]').forEach(button => {
            const audioSrc = button.getAttribute('data-audio');
            const audio = new Audio(audioSrc);
            let isPlaying = false;

            // icons
            const playIcon = button.querySelector('.play');
            const pauseIcon = button.querySelector('.pause');

            button.addEventListener('click', function () {
                if (isPlaying) {
                    pauseAudio();
                } else {
                    playAudio();
                }
            });

            // ao terminar o áudio, reseta o estado
            audio.addEventListener('ended', () => {
                isPlaying = false;
                toggleIcons();
            });

            function playAudio() {
                audio.play();
                isPlaying = true;
                toggleIcons();
            }

            function pauseAudio() {
                audio.pause();
                isPlaying = false;
                toggleIcons();
            }

            // play/pause icons toggle
            function toggleIcons() {
                playIcon.classList.toggle('d-none', isPlaying);
                pauseIcon.classList.toggle('d-none', !isPlaying);
            }
        });
    }


    // swipers
    const swiperStories = new Swiper('.swiper-stories', {
        slidesPerView: "auto",
        loop: true,
        spaceBetween: 32,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // models slider (mobile only)
    const swiperModels = new Swiper('.swiper-models', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 16,
        centeredSlides: true,
        navigation: {
            nextEl: '.model--nav--next',
            prevEl: '.model--nav--prev',
        },
        breakpoints: {
            999: {
                enabled: false,
            }
        }
    });
});
